import { Form as FormAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  h3.ant-typography {
    font-size: 20px;
    color: #676A6C;
    margin-top: 40px;
  }

  .resize-textarea-none{
    textarea{
      resize: none;
    }
  }
`;

export const FormItem = styled(FormAntd.Item)`
  flex-direction: row !important;
  position: absolute;
  right: 39px;

  button.ant-switch {
    top: -5px;
    left: 10px;
  }
`;
